<template>
  <label
    :for="getFieldID(schema)"
    @click="onClick()"
    :class="{checked: value}"
  >
    {{ schema.label }}
    <input
      :id="getFieldID(schema)"
      type="checkbox"
      :checked="value"
      :name="schema.inputName"
      :class="schema.fieldClasses"
      v-model="value"
    >
  </label>
</template>

<script>
import { abstractField } from 'vue-form-generator'

export default {
  mixins: [abstractField],
  methods: {
    onClick () {
      this.value = !this.value
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
